"use client";
import image from "@/constants/image";
import { APP_ROUTES } from "@/constants/routes";
import { montserrat } from "@/lib/font";
import { Report } from "@/models/report";
import SearchIcon from "@mui/icons-material/Search";
import {
  Box,
  FormControl,
  IconButton,
  ListItemButton,
  Typography,
} from "@mui/material";
import { useLocale, useTranslations } from "next-intl";
import Image from "next/image";
import { useRouter } from "next/navigation";
import React, { useRef } from "react";

interface ListTextResult {
  name: string;
  url: string;
}

export interface InputSearchHeaderProps {
  keyword?: string;
  className?: string;
  placeholder?: string;
  focusSearch?: boolean;
  reports?: Report[];
  onFocus?: () => void;
  onBlur?: () => void;
  onClose: () => void;
  onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
  handleSelectItem: (url: string) => void;
  translation_placeholder_key?: string;
  searchValue?: string;
}

const InputSearchHeader = (props: InputSearchHeaderProps) => {
  const {
    keyword,
    reports,
    className,
    placeholder,
    focusSearch,
    onChange,
    onFocus,
    onBlur,
    onClose,
    translation_placeholder_key,
    // searchValue,
  } = props;
  const router = useRouter();
  const t = useTranslations("messages");
  const locale = useLocale();
  const valueInput = useRef<HTMLInputElement>(null);

  const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === "Enter") {
      const value = valueInput.current?.value;
      if (!value) {
        router.push(`${APP_ROUTES(locale).HOME.to}`);
      } else router.push(`/${locale}/search?keyword=${value}`);
      onClose();
    }
  };
  const handleRedirect = (
    slug: string,
    pdf?: boolean,
    haveInteractive?: boolean
  ) => {
    if (pdf) {
      return APP_ROUTES(locale).HOME.DETAIL.MODE.PDF.to(slug);
    } else if (haveInteractive) {
      return APP_ROUTES(locale).HOME.DETAIL.MODE.POWERBI.to(slug);
    } else {
      return APP_ROUTES(locale).HOME.DETAIL.MODE.PDF.to(slug);
    }
  };
  return (
    <FormControl>
      <Box
        className={`bg-gray_5 rounded-full py-3 px-4 gap-[10px] flex items-center ${className}`}
      >
        <IconButton
          className="!p-0"
          onClick={() => {
            const value = valueInput.current?.value;
            if (!value) {
              router.push(`${APP_ROUTES(locale).HOME.to}`);
            } else router.push(`/search?keyword=${value}`);
          }}
        >
          <SearchIcon className="text-[#A4A4A4]" />
        </IconButton>
        <input
          type="text"
          className={`border-none w-full p-0 h-4 bg-gray_5 focus:outline-none font-medium text-base/4 text-gray_60 ${montserrat}`}
          placeholder={placeholder}
          translation-placeholder-key={translation_placeholder_key}
          onChange={onChange}
          onFocus={onFocus}
          onBlur={onBlur}
          onKeyDown={handleKeyDown}
          value={keyword}
          autoComplete="off"
          ref={valueInput}
        />
        {focusSearch && (
          <Box className="bg-gray_5 absolute top-12 left-0 z-[99] w-full rounded-bl-[11px] rounded-br-[11px] boxSearchMobile">
            {reports?.map((item, index) => (
              <ListItemButton
                key={index}
                component="a"
                className="py-1 pl-4 gap-4 cursor-pointer hover:!bg-ciBlue_light_4"
                href={handleRedirect(
                  item.slug,
                  item.havePDF,
                  item.haveInteractive
                )}
              >
                <Box className="pl-2 gap-4">
                  <Box className="text-gray_90 text-sm/6 font-medium">
                    {item.title}
                  </Box>
                  <Box className="flex gap-2">
                    {item.haveInteractive && (
                      <Box className="flex gap-2 items-center">
                        <Image
                          src={image.icDouble}
                          alt="icDouble"
                          className="w-4 h-4"
                        />
                        <Typography
                          className="text-gray_60 text-xs/4 font-normal "
                          translation-key="home_interactive"
                        >
                          {t("home_interactive")}
                        </Typography>
                      </Box>
                    )}
                    {item.havePDF && (
                      <Box className="flex gap-2 items-center">
                        <Image
                          src={image.iconPDF}
                          alt="icDouble"
                          className="w-4 h-4"
                        />
                        <Typography className="text-gray_60 text-xs/4 font-normal ">
                          PDF
                        </Typography>
                      </Box>
                    )}
                  </Box>
                </Box>
              </ListItemButton>
            ))}

            {valueInput.current?.value && (
              <ListItemButton
                key={"search-for"}
                component="a"
                className="!py-4 pl-4 gap-4 cursor-pointer hover:!bg-ciBlue_light_4"
                onClick={() => {
                  const value = valueInput.current?.value;
                  if (!value) {
                    return;
                  }
                  router.push(`/search?keyword=${value}`);
                }}
              >
                <Box className=" gap-4">
                  <Box
                    translation-key="common_search_for"
                    className="text-gray_90 text-sm/6 font-medium"
                  >
                    <IconButton className="!p-0 !mr-1">
                      <SearchIcon className="text-[#A4A4A4]" />
                    </IconButton>
                    {`${t("common_search_for")} "${valueInput.current?.value}"`}
                  </Box>
                </Box>
              </ListItemButton>
            )}
            {/* <Box className="px-4 pt-2 pb-4 gap-[10px]">
              <Button
                className="px-4 py-2 gap-1 text-sm/6 font-medium text-ciBlue_900"
                onClick={() => {
                  const value = valueInput.current?.value;
                  router.push(`/search?keyword=${value}`);
                }}
                translation-key="common_view_full_result"
              >
                {t("common_view_full_result")}
              </Button>
            </Box> */}
          </Box>
        )}
      </Box>
    </FormControl>
  );
};

export default InputSearchHeader;
